import { ApiState } from "infrastructure/api";
import type { RepositoryState } from "./types";

export const withState = <TState extends object>(state: Omit<RepositoryState<TState>, 'apiState'>) =>
    () => ({
        apiState: ApiState.Idle,
        ...state
    });

export default withState;
